import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import DescriptionCard from '../../../shared/library/cards/description';
import {ComponentContainer} from './shared/styles';
import {Query} from 'react-apollo';
import gql from 'graphql-tag';
import {serviceFields} from '../../../data/shared/fragments';
import Spinner from '../../../shared/library/indicators/indeterminate/circular';
import JobCard from '../../../shared/library/cards/jobs/jobs-card';
import {PHONE} from '../../../shared/style/breakpoints';
import NavAnchor, {NAV_ANCHOR_OFFSET} from './shared/nav-anchor';
import {BASE_TEXT} from '../../../shared/style/typography';
import {FOCUS_BLUE} from '../../../shared/style/colors';
import withErrorBoundary from '../../../shared/enhancers/error-boundary';

const Grid = glamorous.div({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  [PHONE]: {
    gridTemplateColumns: '1fr'
  },
  gap: 20,
  marginTop: 20
});

const Center = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 40,
  marginBottom: 40
});

const Link = glamorous.a({
  fontFamily: BASE_TEXT,
  color: FOCUS_BLUE,
  marginTop: 20,
  display: 'block'
});

export const jobs = gql`
  query jobs($id: ID!, $first: Int) {
    tool(id: $id) {
      jobsList(first: $first) {
        count
        edges {
          node {
            id
            angellistJobUrl
            title
            location
            services {
              ...serviceFields
            }
            company {
              name
              imageUrl
              path
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      id
    }
  }
  ${serviceFields}
`;

const Jobs = ({tool}) => {
  return (
    <ComponentContainer>
      <NavAnchor id="jobs" offset={NAV_ANCHOR_OFFSET} />
      <DescriptionCard
        heading={`Jobs that mention ${tool.name} as a desired skillset`}
        description=""
      />
      <Query query={jobs} variables={{id: tool.id, first: 6}}>
        {resp =>
          !resp || resp.loading || !resp.data || !resp.data.tool ? (
            <Center>
              <Spinner />
            </Center>
          ) : (
            <>
              <Grid>
                {resp.data.tool.jobsList.edges.map(e => (
                  <JobCard
                    id={e.node.id}
                    key={e.node.id}
                    services={e.node.services}
                    title={e.node.title}
                    url={e.node.angellistJobUrl}
                    location={e.node.location}
                    companyName={e.node.company.name}
                    companyLogo={e.node.company.imageUrl}
                    path={e.node.company.path}
                  >
                    Jobs Card
                    {e.node.title}
                  </JobCard>
                ))}
              </Grid>
            </>
          )
        }
      </Query>
      <Link href={`/jobs/${tool.slug}`} title={`${tool.name} jobs`}>
        See all jobs
      </Link>
    </ComponentContainer>
  );
};

Jobs.propTypes = {
  tool: PropTypes.object
};

export default withErrorBoundary(true)(Jobs);
